
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venue/[venueName]/terms",
      function () {
        return require("private-next-pages/venue/[venueName]/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venue/[venueName]/terms"])
      });
    }
  